import {
  Waves, Umbrella, Flower2, Utensils, Wine, Wifi, ConciergeBell, Fish, Dumbbell, Bus, Presentation,
  Accessibility, Baby, Mountain, Flag, Bike, Map, Ship, Tv, Trophy, Anchor, Sparkles, PawPrint, Car,
  Snowflake, Shirt, Trees, Flame, Coffee, Lock, Bath, ShowerHead, Refrigerator, Dog, Plane, Gamepad2,
  Sun, CookingPot, Phone, Wind, Cigarette, CigaretteOff, Music, Telescope, Tent, Baby as Crib,
} from "lucide-react";

const MAP = {
  Pool: [Waves, "Pool"], SwimmingPool: [Waves, "Pool"], Beach: [Umbrella, "Beach"], Spa: [Flower2, "Spa"],
  Restaurant: [Utensils, "Restaurant"], Bar: [Wine, "Bar"], WirelessInternetAccess: [Wifi, "Wi-Fi"], WiFi: [Wifi, "Wi-Fi"],
  InternetAccess: [Wifi, "Internet"], RoomService: [ConciergeBell, "Room service"], Snorkeling: [Fish, "Snorkelling"],
  Fishing: [Anchor, "Fishing"], ScubaDiving: [Fish, "Scuba diving"], Gym: [Dumbbell, "Gym"], FitnessCentre: [Dumbbell, "Gym"],
  BusService: [Bus, "Shuttle"], AirportShuttle: [Plane, "Airport shuttle"], ConferenceFacilities: [Presentation, "Conferencing"],
  DisabledAccess: [Accessibility, "Accessible"], ChildrenWelcome: [Baby, "Kids welcome"], Hiking: [Mountain, "Hiking"],
  Golf: [Flag, "Golf"], QuadBiking: [Bike, "Quad biking"], HorseRiding: [Trophy, "Horse riding"], SightSeeingTours: [Map, "Tours"],
  Catamaran: [Ship, "Catamaran"], SatelliteTV: [Tv, "Satellite TV"], TV: [Tv, "TV"], Television: [Tv, "TV"], Tennis: [Trophy, "Tennis"],
  Game: [PawPrint, "Game drives"], GameDrives: [PawPrint, "Game drives"], Parking: [Car, "Parking"], FreeParking: [Car, "Free parking"],
  AirConditioning: [Snowflake, "Air conditioning"], Laundry: [Shirt, "Laundry"], Garden: [Trees, "Garden"], Fireplace: [Flame, "Fireplace"],
  Breakfast: [Coffee, "Breakfast"], TeaAndCoffee: [Coffee, "Tea & coffee"], Safe: [Lock, "In-room safe"], Bathtub: [Bath, "Bathtub"],
  Shower: [ShowerHead, "Shower"], Minibar: [Refrigerator, "Minibar"], Fridge: [Refrigerator, "Fridge"], PetsAllowed: [Dog, "Pets allowed"],
  GamesRoom: [Gamepad2, "Games room"], Balcony: [Sun, "Balcony"], Terrace: [Sun, "Terrace"], Kitchen: [CookingPot, "Kitchen"],
  Kitchenette: [CookingPot, "Kitchenette"], Telephone: [Phone, "Telephone"], Fan: [Wind, "Fan"], Smoking: [Cigarette, "Smoking"],
  NonSmoking: [CigaretteOff, "Non-smoking"], Entertainment: [Music, "Entertainment"], Stargazing: [Telescope, "Stargazing"],
  Camping: [Tent, "Camping"], Cot: [Crib, "Baby cot"],
};

const pretty = (n) => n.replace(/([a-z])([A-Z])/g, "$1 $2");
const norm = (n) => n.toLowerCase().replace(/[^a-z0-9]/g, "");
const LOOKUP = Object.fromEntries(Object.entries(MAP).map(([k, v]) => [norm(k), v]));
Object.assign(LOOKUP, { teacoffee: MAP.TeaAndCoffee, wifi: MAP.WiFi, minibar: MAP.Minibar, babycot: MAP.Cot });

export const Amenity = ({ name, showLabel = true }) => {
  const [Icon, label] = LOOKUP[norm(name)] || [Sparkles, pretty(name)];
  return (
    <span className="inline-flex items-center gap-1.5 text-xs text-ink/70" title={label} data-testid={`amenity-${name}`}>
      <Icon className="h-4 w-4 shrink-0 text-brand" strokeWidth={1.5} />
      {showLabel && label}
    </span>
  );
};

export const AmenityList = ({ features = [], limit, showLabel = true, testid, className = "" }) => (features.length ? (
  <div className={`flex flex-wrap gap-x-4 gap-y-2 ${className}`} data-testid={testid}>
    {(limit ? features.slice(0, limit) : features).map((f) => <Amenity key={f} name={f} showLabel={showLabel} />)}
    {limit && features.length > limit && <span className="text-xs text-ink/50">+{features.length - limit} more</span>}
  </div>
) : null);
